import { render, staticRenderFns } from "./person_summary.vue?vue&type=template&id=61b140b8&"
import script from "./person_summary.vue?vue&type=script&lang=js&"
export * from "./person_summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61b140b8')) {
      api.createRecord('61b140b8', component.options)
    } else {
      api.reload('61b140b8', component.options)
    }
    module.hot.accept("./person_summary.vue?vue&type=template&id=61b140b8&", function () {
      api.rerender('61b140b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/profile/person_summary.vue"
export default component.exports